export type EmployeesState = {
  currentEmployee?: {
    agent_id: string;
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    role: string;
    permanent_customer_accesses: Array<PermanentCustomerAccess>;
  };
};

export type PermanentCustomerAccess = {
  customer_id: number;
};

export const initialState: EmployeesState = {
  currentEmployee: undefined,
};
